import script from "./PayButtonsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PayButtonsPage.vue?vue&type=script&setup=true&lang=ts"

import "./PayButtonsPage.vue?vue&type=style&index=0&id=7c43caf0&scoped=true&lang=css"

import exportComponent from "/app/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c43caf0"]])

export default __exports__